import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'

import Controls from './Controls'
import Columns from './Columns'

import { selectTeams, fetchTeams } from '../../../../slices/teamsSlice'
import useStyles from './styles'

type CardsTabProps = {
  pageRef: React.MutableRefObject<HTMLDivElement>
  tabState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
}

const CardsTab: React.FC<CardsTabProps> = () => {
  const dispatch = useAppDispatch()

  const { loaded, loading } = useAppSelector(selectTeams)

  const classes = useStyles()

  // Load teams if needed
  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchTeams())
    }
  }, [loaded, loading, dispatch])

  return (
    <div className={classes.root}>
      <Controls />

      <Columns />
    </div>
  )
}

export default CardsTab
